import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section
      className="min-h-screen flex items-center justify-center"
      style={{ backgroundColor: "var(--cr-cream)" }}
      data-testid="notfound-page"
    >
      <div className="cr-container-narrow px-6 md:px-8 text-center py-32">
        <p className="eyebrow mb-6">Page introuvable</p>
        <h1 className="cr-h1 mb-8">
          Cette parenthèse <span className="font-display-italic">n'existe pas</span>.
        </h1>
        <p className="cr-lede mb-12 max-w-xl mx-auto">
          Le chemin que vous cherchez s'est égaré dans le jardin du refuge.
        </p>
        <Link to="/accueil" data-testid="notfound-cta-home" className="cr-btn">
          Retour à l'accueil
        </Link>
      </div>
    </section>
  );
}
